var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveTable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1299 8.91913L18.8191 4.33579C18.7091 3.94163 18.3516 3.66663 17.9391 3.66663H4.06075C3.64825 3.66663 3.29075 3.94163 3.18075 4.33579L1.86992 8.91913C1.70492 9.49663 2.14492 10.0833 2.74992 10.0833H4.76659L3.66659 18.3333H5.49992L6.11409 13.75H15.8949L16.4999 18.3333H18.3333L17.2333 10.0833H19.2499C19.8549 10.0833 20.2949 9.49663 20.1299 8.91913ZM6.35242 11.9166L6.59992 10.0833H15.3999L15.6474 11.9166H6.35242Z",
    fill: "#29ae00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_734"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#29ae00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveTable);
export default __webpack_public_path__ + "static/media/active-table.ee7639ab5a497f3b55a687f3f146e88d.svg";
export { ForwardRef as ReactComponent };